import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-loaders-page-ui',
    templateUrl: './bb-loaders-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbLoadersPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
